import React from 'react';
import Button from '@qc/particle/lib/components/button';
import { Card } from "../pages/ProductMatrix.styles";
import { faUserPlus } from '@fortawesome/pro-light-svg-icons';

import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const CardTier = styled(Card)`
  width: 360px;
  margin: 8px;
  padding: 24px 24px 24px;
`;

export const H2 = styled.h2`
    margin-top: 8px;
    margin-bottom: 5px;
    font-weight: 600;
    color: #262626;
    font-size: 24px;
`;

export const TierDescription = styled.p`
    margin-top: 0px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e8e9ea;
    font-weight: 400;
    font-size: 14px;
    color: #262626;
    height: 82px;
`;

export const TierFeatures = styled.div`
    padding: 0;
    margin-bottom: 15px;
    height: 110px;
`

export const ListItem = styled.div`
    display: flex;
    justify-content: space-between;
`

export const ListIconGood = styled.div`
    width: 8%;
    paddingLeft: 10px;
    color: #52C41A;
`

export const ListItemGoodText = styled.div`
    width: 92%;
    paddingLeft: 2px;
`

export const ListIconBad = styled.div`
    width: 8%;
    paddingLeft: 10px;
    color: #8C8C8C;
`

export const ListItemBadText = styled.div`
    width: 92%;
    paddingLeft: 2px;
    color: #8C8C8C;
`

export const SignUpButton = styled(Button)`
  width: 100%
`

const TierFeature = ({ type, keyVal, content }) => {
    return (
        <ListItem>
            { type === "bad" ? <ListIconBad key={`${keyVal}-icon`}>–</ListIconBad> : <ListIconGood key={`${keyVal}-icon`}>✓</ListIconGood> }
            { type === "bad" ? <ListItemBadText key={`${keyVal}-content`}>{content}</ListItemBadText> : <ListItemGoodText key={`${keyVal}-content`}>{content}</ListItemGoodText>}
        </ListItem>
    )
}

const ProductTierOption = ({
    disabled,
    icon,
    tierName,
    description,
    includedFeatures,
    missingFeatures,
    clickHandler,
    buttonText
}) => {
    return (
        <CardTier>
            <FontAwesomeIcon icon={icon} fontSize="40px"/>
            <H2>{tierName}</H2>
            <TierDescription>{description}</TierDescription>
            <TierFeatures>
                {includedFeatures.map((feature, index) => <TierFeature type='good' key={index} content={feature} />)}
                {missingFeatures.map((feature, index) => <TierFeature type='bad' key={index} content={feature} />)}
            </TierFeatures>
            <SignUpButton type='secondary' onClick={clickHandler} disabled={disabled}>
                {buttonText}
            </SignUpButton>
        </CardTier>
    )
}

export default ProductTierOption